import { uploadFile } from 'react-s3';
import { v4 as uuid } from 'uuid';

window.Buffer = window.Buffer || require('buffer').Buffer;

/**
 * Upload file to S3 bucket. Returns a promise that resolves with the data returned from the upload process
 * @param {Object} file - file object, usually from e.target.files
 * @param {Promise}
 */

export default function uploadToS3Bucket(file) {
    console.log('process', process.env);
    const config = {
        bucketName: process.env.REACT_APP_AWS_S3_FILES_BUCKET,
        region: process.env.REACT_APP_AWS_REGION,
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
        dirName: uuid()
    };

    return uploadFile(file, config);
}
